import React from "react";

// Input field
function InputField({ label, type, onChange, value, name }) {
  return (
    <div className='input-wrapper'>
      <label className="input">
        <span className='label'>{label}</span>
        <div className='input-type'>
          <div className='div_wrapper'>
            <div className='vertical_divs'>
              <div className='yellow'></div>
              <div className='pink'></div>
            </div>
            <div className='blue'></div>
          </div>
          <input type={type} onChange={onChange} value={value} name={name} required/>
        </div>
      </label>
    </div>
  );
}

export default InputField;
